/**
 * @flow
 * @relayHash 8422dbf87e57534619c5b7a87914b9e7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SignatureBlockFieldVisibility = "HIDE" | "SHOW" | "%future added value";
export type CreateCTemplateSignatureBlockInput = {
  clientMutationId?: ?string,
  c_template_id: string,
  signing_party: string,
  name_visibility: SignatureBlockFieldVisibility,
  email_visibility: SignatureBlockFieldVisibility,
  title_visibility: SignatureBlockFieldVisibility,
  company_name_visibility: SignatureBlockFieldVisibility,
  phone_visibility: SignatureBlockFieldVisibility,
  address_visibility: SignatureBlockFieldVisibility,
};
export type Terms_ContractTemplate_createCTemplateSignatureBlockMutationVariables = {|
  input: CreateCTemplateSignatureBlockInput
|};
export type Terms_ContractTemplate_createCTemplateSignatureBlockMutationResponse = {|
  +createCTemplateSignatureBlock: ?{|
    +new_c_template_signature_block_edge: ?{|
      +node: ?{|
        +id: string,
        +address_visibility: ?SignatureBlockFieldVisibility,
        +company_name_visibility: ?SignatureBlockFieldVisibility,
        +email_visibility: ?SignatureBlockFieldVisibility,
        +name_visibility: ?SignatureBlockFieldVisibility,
        +phone_visibility: ?SignatureBlockFieldVisibility,
        +signing_party: ?string,
        +title_visibility: ?SignatureBlockFieldVisibility,
      |}
    |}
  |}
|};
export type Terms_ContractTemplate_createCTemplateSignatureBlockMutation = {|
  variables: Terms_ContractTemplate_createCTemplateSignatureBlockMutationVariables,
  response: Terms_ContractTemplate_createCTemplateSignatureBlockMutationResponse,
|};
*/


/*
mutation Terms_ContractTemplate_createCTemplateSignatureBlockMutation(
  $input: CreateCTemplateSignatureBlockInput!
) {
  createCTemplateSignatureBlock(input: $input) {
    new_c_template_signature_block_edge {
      node {
        id
        address_visibility
        company_name_visibility
        email_visibility
        name_visibility
        phone_visibility
        signing_party
        title_visibility
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCTemplateSignatureBlockInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createCTemplateSignatureBlock",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateCTemplateSignatureBlockInput!"
      }
    ],
    "concreteType": "CreateCTemplateSignatureBlockPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "new_c_template_signature_block_edge",
        "storageKey": null,
        "args": null,
        "concreteType": "CTemplateSignatureBlockEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "CTemplateSignatureBlock",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "address_visibility",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "company_name_visibility",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email_visibility",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name_visibility",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "phone_visibility",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "signing_party",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "title_visibility",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Terms_ContractTemplate_createCTemplateSignatureBlockMutation",
  "id": null,
  "text": "mutation Terms_ContractTemplate_createCTemplateSignatureBlockMutation(\n  $input: CreateCTemplateSignatureBlockInput!\n) {\n  createCTemplateSignatureBlock(input: $input) {\n    new_c_template_signature_block_edge {\n      node {\n        id\n        address_visibility\n        company_name_visibility\n        email_visibility\n        name_visibility\n        phone_visibility\n        signing_party\n        title_visibility\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Terms_ContractTemplate_createCTemplateSignatureBlockMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "Terms_ContractTemplate_createCTemplateSignatureBlockMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c7441cc4ee2ec782b2358f7e890fef67';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/Contract/__generated__/Terms_ContractTemplate_createCTemplateSignatureBlockMutation.graphql.js